import { usePostHogEvents } from '@/hooks/usePostHogEvents';
import { OnlineStore } from '@/types/storesType';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { generateDirectusSrc, generateDirectusSrcSet } from '@/helpers/image';

const OnlineStoresList = ({
  online_stores,
}: {
  online_stores: OnlineStore[];
}) => {
  const [showMore, setShowMore] = useState(false);
  const [itemsPerRow, setItemsPerRow] = useState(3);
  const { sendDistributorClickEvent } = usePostHogEvents();

  useEffect(() => {
    const updateItemsPerRow = () => {
      if (window.innerWidth >= 640) {
        setItemsPerRow(4);
      } else {
        setItemsPerRow(3);
      }
    };

    updateItemsPerRow();

    window.addEventListener('resize', updateItemsPerRow);

    return () => window.removeEventListener('resize', updateItemsPerRow);
  }, []);

  const maxVisibleStores = itemsPerRow * 2;

  const visibleStores = showMore
    ? online_stores
    : online_stores?.slice(0, maxVisibleStores);

  if (online_stores?.length <= 0) return null;

  return (
    <div>
      <p className="font-semibold mb-2 font-proxima_font">
        Also available online at:
      </p>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
        {visibleStores?.map((store, index) => (
          <Link
            href={
              store?.product_online_store_translations_id?.product_store_url ||
              '#'
            }
            target="_blank"
            onClick={() => {
              sendDistributorClickEvent(
                store?.products_translations_id.id,
                store?.products_translations_id.title,
                store?.product_online_store_translations_id?.store?.name
              );
            }}
            rel="noopener noreferrer"
            key={index}
            className="border-2 border-border-gray hover:border-black duration-100 cursor-pointer rounded-md h-14 w-full p-1 flex items-center justify-center"
          >
            <img
              src={generateDirectusSrc(
                store.product_online_store_translations_id.store.image,
                200
              )}
              srcSet={generateDirectusSrcSet(
                store.product_online_store_translations_id.store.image
              )}
              alt={store.product_online_store_translations_id.store.name}
              width={100}
              height={100}
              sizes="(max-width: 640px) 30vw, (max-width: 1024px) 20vw, 150px"
              className="h-12 w-auto object-contain"
              loading="lazy"
            />
          </Link>
        ))}
      </div>

      {online_stores?.length > maxVisibleStores && (
        <button
          onClick={() => setShowMore(!showMore)}
          className="mt-4 px-1 mx-auto font-semibold font-proxima_font flex items-center gap-1"
        >
          {showMore ? 'Show Less' : 'Show More'}
          <span className={`chevron ${showMore ? 'up' : 'down'}`} />
        </button>
      )}
    </div>
  );
};

export default OnlineStoresList;
